import React, { useState, useEffect } from 'react';
import { BookOpenCheck } from 'lucide-react';
import './SATVocabFountain.css';

const SATVocabFountain = () => {
  const wordPool = [
    'Ameliorate', 'Ephemeral', 'Esoteric', 'Grandiloquent', 'Ineffable',
    'Juxtapose', 'Mellifluous', 'Nefarious', 'Obfuscate', 'Paraphernalia',
    'Quotidian', 'Ruminate', 'Sycophant', 'Ubiquitous', 'Voracious',
    'Xenophile', 'Zealous', 'Banal', 'Capricious', 'Fastidious'
  ];

  const [fountainWords, setFountainWords] = useState([]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const newWordText = wordPool[Math.floor(Math.random() * wordPool.length)];
      
      const newWord = {
        id: Math.random() + Date.now(), 
        text: newWordText,
        // Burst paths tuned to look great inside the natural container height
        vectorX: (Math.random() - 0.5) * 220, 
        apexY: -100 - Math.random() * 80, 
        spin: (Math.random() - 0.5) * 35
      };

      setFountainWords(prev => {
        const nextState = [...prev, newWord];
        if (nextState.length > 10) {
          nextState.shift();
        }
        return nextState;
      });

    }, 500); 

  return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="tpa-summer-card tpa-summer-vocab-fountain-card tpa-summer-dark">
      
      {/* Background Fountain Overlay */}
      <div className="tpa-summer-fountain-overlay">
        {fountainWords.map(word => (
          <span 
            key={word.id} 
            className="tpa-summer-fountain-word"
            style={{ 
              '--burst-x': `${word.vectorX}px`,
              '--apex-y': `${word.apexY}px`,
              '--spin': `${word.spin}deg`
            }}
          >
            {word.text}
          </span>
        ))}
      </div>

      {/* Text Contents Bottom-Justified */}
      <div className="tpa-summer-card-contents tpa-summer-masked">
        <h3 className="tpa-summer-h3"><BookOpenCheck size={20} />VOCAB TRAINING</h3>
        
        <div className="tpa-summer-promo-box-clean">
          <h4 className="tpa-summer-h4-small">OPEN 24/7 ONLINE</h4>
          <p className="tpa-summer-p-tag-gold">SELF-PACED MASTERY</p>
        </div>
      </div>
    </div>
  );
};

export default SATVocabFountain;